// source: legebill/site/tag/v4/tag.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_field_mask_pb = require('google-protobuf/google/protobuf/field_mask_pb.js');
goog.object.extend(proto, google_protobuf_field_mask_pb);
var google_api_annotations_pb = require('../../../../google/api/annotations_pb.js');
goog.object.extend(proto, google_api_annotations_pb);
var legebill_type_tag_pb = require('../../../../legebill/type/tag_pb.js');
goog.object.extend(proto, legebill_type_tag_pb);
var legebill_type_tag_category_pb = require('../../../../legebill/type/tag_category_pb.js');
goog.object.extend(proto, legebill_type_tag_category_pb);
goog.exportSymbol('proto.legebill.site.tag.v4.BatchGetTagCategoriesRequest', null, global);
goog.exportSymbol('proto.legebill.site.tag.v4.BatchGetTagCategoriesResponse', null, global);
goog.exportSymbol('proto.legebill.site.tag.v4.BatchGetTagsRequest', null, global);
goog.exportSymbol('proto.legebill.site.tag.v4.BatchGetTagsResponse', null, global);
goog.exportSymbol('proto.legebill.site.tag.v4.BatchListTagsByCategoriesRequest', null, global);
goog.exportSymbol('proto.legebill.site.tag.v4.BatchListTagsByCategoriesResponse', null, global);
goog.exportSymbol('proto.legebill.site.tag.v4.CreateFavouriteTagRequest', null, global);
goog.exportSymbol('proto.legebill.site.tag.v4.CreateTagKeywordRequest', null, global);
goog.exportSymbol('proto.legebill.site.tag.v4.CreateTagRequest', null, global);
goog.exportSymbol('proto.legebill.site.tag.v4.DeleteAllConnectorTagsRequest', null, global);
goog.exportSymbol('proto.legebill.site.tag.v4.DeleteFavouriteTagRequest', null, global);
goog.exportSymbol('proto.legebill.site.tag.v4.DeleteTagKeywordRequest', null, global);
goog.exportSymbol('proto.legebill.site.tag.v4.DeleteTagRequest', null, global);
goog.exportSymbol('proto.legebill.site.tag.v4.FavouriteTag', null, global);
goog.exportSymbol('proto.legebill.site.tag.v4.GetTagCategoryRequest', null, global);
goog.exportSymbol('proto.legebill.site.tag.v4.GetTagRequest', null, global);
goog.exportSymbol('proto.legebill.site.tag.v4.ListFavouriteTagsRequest', null, global);
goog.exportSymbol('proto.legebill.site.tag.v4.ListFavouriteTagsResponse', null, global);
goog.exportSymbol('proto.legebill.site.tag.v4.ListRecentTagsRequest', null, global);
goog.exportSymbol('proto.legebill.site.tag.v4.ListRecentTagsResponse', null, global);
goog.exportSymbol('proto.legebill.site.tag.v4.ListTagsByCategoryRequest', null, global);
goog.exportSymbol('proto.legebill.site.tag.v4.ListTagsByCategoryResponse', null, global);
goog.exportSymbol('proto.legebill.site.tag.v4.ListTagsRequest', null, global);
goog.exportSymbol('proto.legebill.site.tag.v4.ListTagsResponse', null, global);
goog.exportSymbol('proto.legebill.site.tag.v4.ReorderFavouriteTagRequest', null, global);
goog.exportSymbol('proto.legebill.site.tag.v4.ReorderFavouriteTagResponse', null, global);
goog.exportSymbol('proto.legebill.site.tag.v4.SearchTagsRequest', null, global);
goog.exportSymbol('proto.legebill.site.tag.v4.SearchTagsRequest.OrderBy', null, global);
goog.exportSymbol('proto.legebill.site.tag.v4.SearchTagsResponse', null, global);
goog.exportSymbol('proto.legebill.site.tag.v4.SearchTagsResponseShallow', null, global);
goog.exportSymbol('proto.legebill.site.tag.v4.TagCategoryMembership', null, global);
goog.exportSymbol('proto.legebill.site.tag.v4.TagUpdate', null, global);
goog.exportSymbol('proto.legebill.site.tag.v4.UpdateTagRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.tag.v4.GetTagRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.tag.v4.GetTagRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.tag.v4.GetTagRequest.displayName = 'proto.legebill.site.tag.v4.GetTagRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.tag.v4.UpdateTagRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.tag.v4.UpdateTagRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.tag.v4.UpdateTagRequest.displayName = 'proto.legebill.site.tag.v4.UpdateTagRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.tag.v4.TagUpdate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.legebill.site.tag.v4.TagUpdate.repeatedFields_, null);
};
goog.inherits(proto.legebill.site.tag.v4.TagUpdate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.tag.v4.TagUpdate.displayName = 'proto.legebill.site.tag.v4.TagUpdate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.tag.v4.ListTagsByCategoryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.tag.v4.ListTagsByCategoryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.tag.v4.ListTagsByCategoryRequest.displayName = 'proto.legebill.site.tag.v4.ListTagsByCategoryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.tag.v4.ListTagsByCategoryResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.legebill.site.tag.v4.ListTagsByCategoryResponse.repeatedFields_, null);
};
goog.inherits(proto.legebill.site.tag.v4.ListTagsByCategoryResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.tag.v4.ListTagsByCategoryResponse.displayName = 'proto.legebill.site.tag.v4.ListTagsByCategoryResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.tag.v4.BatchListTagsByCategoriesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.legebill.site.tag.v4.BatchListTagsByCategoriesRequest.repeatedFields_, null);
};
goog.inherits(proto.legebill.site.tag.v4.BatchListTagsByCategoriesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.tag.v4.BatchListTagsByCategoriesRequest.displayName = 'proto.legebill.site.tag.v4.BatchListTagsByCategoriesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.tag.v4.BatchListTagsByCategoriesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.legebill.site.tag.v4.BatchListTagsByCategoriesResponse.repeatedFields_, null);
};
goog.inherits(proto.legebill.site.tag.v4.BatchListTagsByCategoriesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.tag.v4.BatchListTagsByCategoriesResponse.displayName = 'proto.legebill.site.tag.v4.BatchListTagsByCategoriesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.tag.v4.TagCategoryMembership = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.legebill.site.tag.v4.TagCategoryMembership.repeatedFields_, null);
};
goog.inherits(proto.legebill.site.tag.v4.TagCategoryMembership, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.tag.v4.TagCategoryMembership.displayName = 'proto.legebill.site.tag.v4.TagCategoryMembership';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.tag.v4.ListTagsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.tag.v4.ListTagsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.tag.v4.ListTagsRequest.displayName = 'proto.legebill.site.tag.v4.ListTagsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.tag.v4.ListTagsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.legebill.site.tag.v4.ListTagsResponse.repeatedFields_, null);
};
goog.inherits(proto.legebill.site.tag.v4.ListTagsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.tag.v4.ListTagsResponse.displayName = 'proto.legebill.site.tag.v4.ListTagsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.tag.v4.DeleteAllConnectorTagsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.tag.v4.DeleteAllConnectorTagsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.tag.v4.DeleteAllConnectorTagsRequest.displayName = 'proto.legebill.site.tag.v4.DeleteAllConnectorTagsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.tag.v4.SearchTagsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.tag.v4.SearchTagsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.tag.v4.SearchTagsRequest.displayName = 'proto.legebill.site.tag.v4.SearchTagsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.tag.v4.SearchTagsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.legebill.site.tag.v4.SearchTagsResponse.repeatedFields_, null);
};
goog.inherits(proto.legebill.site.tag.v4.SearchTagsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.tag.v4.SearchTagsResponse.displayName = 'proto.legebill.site.tag.v4.SearchTagsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.tag.v4.SearchTagsResponseShallow = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.legebill.site.tag.v4.SearchTagsResponseShallow.repeatedFields_, null);
};
goog.inherits(proto.legebill.site.tag.v4.SearchTagsResponseShallow, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.tag.v4.SearchTagsResponseShallow.displayName = 'proto.legebill.site.tag.v4.SearchTagsResponseShallow';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.tag.v4.BatchGetTagsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.legebill.site.tag.v4.BatchGetTagsRequest.repeatedFields_, null);
};
goog.inherits(proto.legebill.site.tag.v4.BatchGetTagsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.tag.v4.BatchGetTagsRequest.displayName = 'proto.legebill.site.tag.v4.BatchGetTagsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.tag.v4.BatchGetTagsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.legebill.site.tag.v4.BatchGetTagsResponse.repeatedFields_, null);
};
goog.inherits(proto.legebill.site.tag.v4.BatchGetTagsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.tag.v4.BatchGetTagsResponse.displayName = 'proto.legebill.site.tag.v4.BatchGetTagsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.tag.v4.CreateTagRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.legebill.site.tag.v4.CreateTagRequest.repeatedFields_, null);
};
goog.inherits(proto.legebill.site.tag.v4.CreateTagRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.tag.v4.CreateTagRequest.displayName = 'proto.legebill.site.tag.v4.CreateTagRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.tag.v4.CreateTagKeywordRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.tag.v4.CreateTagKeywordRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.tag.v4.CreateTagKeywordRequest.displayName = 'proto.legebill.site.tag.v4.CreateTagKeywordRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.tag.v4.DeleteTagKeywordRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.tag.v4.DeleteTagKeywordRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.tag.v4.DeleteTagKeywordRequest.displayName = 'proto.legebill.site.tag.v4.DeleteTagKeywordRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.tag.v4.ListFavouriteTagsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.tag.v4.ListFavouriteTagsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.tag.v4.ListFavouriteTagsRequest.displayName = 'proto.legebill.site.tag.v4.ListFavouriteTagsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.tag.v4.ListFavouriteTagsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.legebill.site.tag.v4.ListFavouriteTagsResponse.repeatedFields_, null);
};
goog.inherits(proto.legebill.site.tag.v4.ListFavouriteTagsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.tag.v4.ListFavouriteTagsResponse.displayName = 'proto.legebill.site.tag.v4.ListFavouriteTagsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.tag.v4.FavouriteTag = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.tag.v4.FavouriteTag, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.tag.v4.FavouriteTag.displayName = 'proto.legebill.site.tag.v4.FavouriteTag';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.tag.v4.CreateFavouriteTagRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.tag.v4.CreateFavouriteTagRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.tag.v4.CreateFavouriteTagRequest.displayName = 'proto.legebill.site.tag.v4.CreateFavouriteTagRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.tag.v4.ReorderFavouriteTagRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.tag.v4.ReorderFavouriteTagRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.tag.v4.ReorderFavouriteTagRequest.displayName = 'proto.legebill.site.tag.v4.ReorderFavouriteTagRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.tag.v4.ReorderFavouriteTagResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.tag.v4.ReorderFavouriteTagResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.tag.v4.ReorderFavouriteTagResponse.displayName = 'proto.legebill.site.tag.v4.ReorderFavouriteTagResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.tag.v4.DeleteFavouriteTagRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.tag.v4.DeleteFavouriteTagRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.tag.v4.DeleteFavouriteTagRequest.displayName = 'proto.legebill.site.tag.v4.DeleteFavouriteTagRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.tag.v4.ListRecentTagsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.tag.v4.ListRecentTagsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.tag.v4.ListRecentTagsRequest.displayName = 'proto.legebill.site.tag.v4.ListRecentTagsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.tag.v4.ListRecentTagsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.legebill.site.tag.v4.ListRecentTagsResponse.repeatedFields_, null);
};
goog.inherits(proto.legebill.site.tag.v4.ListRecentTagsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.tag.v4.ListRecentTagsResponse.displayName = 'proto.legebill.site.tag.v4.ListRecentTagsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.tag.v4.DeleteTagRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.tag.v4.DeleteTagRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.tag.v4.DeleteTagRequest.displayName = 'proto.legebill.site.tag.v4.DeleteTagRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.tag.v4.GetTagCategoryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.tag.v4.GetTagCategoryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.tag.v4.GetTagCategoryRequest.displayName = 'proto.legebill.site.tag.v4.GetTagCategoryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.tag.v4.BatchGetTagCategoriesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.legebill.site.tag.v4.BatchGetTagCategoriesRequest.repeatedFields_, null);
};
goog.inherits(proto.legebill.site.tag.v4.BatchGetTagCategoriesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.tag.v4.BatchGetTagCategoriesRequest.displayName = 'proto.legebill.site.tag.v4.BatchGetTagCategoriesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.tag.v4.BatchGetTagCategoriesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.legebill.site.tag.v4.BatchGetTagCategoriesResponse.repeatedFields_, null);
};
goog.inherits(proto.legebill.site.tag.v4.BatchGetTagCategoriesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.tag.v4.BatchGetTagCategoriesResponse.displayName = 'proto.legebill.site.tag.v4.BatchGetTagCategoriesResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.tag.v4.GetTagRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.tag.v4.GetTagRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.tag.v4.GetTagRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.GetTagRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    tagId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.tag.v4.GetTagRequest}
 */
proto.legebill.site.tag.v4.GetTagRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.tag.v4.GetTagRequest;
  return proto.legebill.site.tag.v4.GetTagRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.tag.v4.GetTagRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.tag.v4.GetTagRequest}
 */
proto.legebill.site.tag.v4.GetTagRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTagId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.tag.v4.GetTagRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.tag.v4.GetTagRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.tag.v4.GetTagRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.GetTagRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTagId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string tag_id = 1;
 * @return {string}
 */
proto.legebill.site.tag.v4.GetTagRequest.prototype.getTagId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.tag.v4.GetTagRequest} returns this
 */
proto.legebill.site.tag.v4.GetTagRequest.prototype.setTagId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.tag.v4.UpdateTagRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.tag.v4.UpdateTagRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.tag.v4.UpdateTagRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.UpdateTagRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    tag: (f = msg.getTag()) && proto.legebill.site.tag.v4.TagUpdate.toObject(includeInstance, f),
    updateMask: (f = msg.getUpdateMask()) && google_protobuf_field_mask_pb.FieldMask.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.tag.v4.UpdateTagRequest}
 */
proto.legebill.site.tag.v4.UpdateTagRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.tag.v4.UpdateTagRequest;
  return proto.legebill.site.tag.v4.UpdateTagRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.tag.v4.UpdateTagRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.tag.v4.UpdateTagRequest}
 */
proto.legebill.site.tag.v4.UpdateTagRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.legebill.site.tag.v4.TagUpdate;
      reader.readMessage(value,proto.legebill.site.tag.v4.TagUpdate.deserializeBinaryFromReader);
      msg.setTag(value);
      break;
    case 3:
      var value = new google_protobuf_field_mask_pb.FieldMask;
      reader.readMessage(value,google_protobuf_field_mask_pb.FieldMask.deserializeBinaryFromReader);
      msg.setUpdateMask(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.tag.v4.UpdateTagRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.tag.v4.UpdateTagRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.tag.v4.UpdateTagRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.UpdateTagRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTag();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.legebill.site.tag.v4.TagUpdate.serializeBinaryToWriter
    );
  }
  f = message.getUpdateMask();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_field_mask_pb.FieldMask.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.legebill.site.tag.v4.UpdateTagRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.tag.v4.UpdateTagRequest} returns this
 */
proto.legebill.site.tag.v4.UpdateTagRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional TagUpdate tag = 2;
 * @return {?proto.legebill.site.tag.v4.TagUpdate}
 */
proto.legebill.site.tag.v4.UpdateTagRequest.prototype.getTag = function() {
  return /** @type{?proto.legebill.site.tag.v4.TagUpdate} */ (
    jspb.Message.getWrapperField(this, proto.legebill.site.tag.v4.TagUpdate, 2));
};


/**
 * @param {?proto.legebill.site.tag.v4.TagUpdate|undefined} value
 * @return {!proto.legebill.site.tag.v4.UpdateTagRequest} returns this
*/
proto.legebill.site.tag.v4.UpdateTagRequest.prototype.setTag = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.legebill.site.tag.v4.UpdateTagRequest} returns this
 */
proto.legebill.site.tag.v4.UpdateTagRequest.prototype.clearTag = function() {
  return this.setTag(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.legebill.site.tag.v4.UpdateTagRequest.prototype.hasTag = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.FieldMask update_mask = 3;
 * @return {?proto.google.protobuf.FieldMask}
 */
proto.legebill.site.tag.v4.UpdateTagRequest.prototype.getUpdateMask = function() {
  return /** @type{?proto.google.protobuf.FieldMask} */ (
    jspb.Message.getWrapperField(this, google_protobuf_field_mask_pb.FieldMask, 3));
};


/**
 * @param {?proto.google.protobuf.FieldMask|undefined} value
 * @return {!proto.legebill.site.tag.v4.UpdateTagRequest} returns this
*/
proto.legebill.site.tag.v4.UpdateTagRequest.prototype.setUpdateMask = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.legebill.site.tag.v4.UpdateTagRequest} returns this
 */
proto.legebill.site.tag.v4.UpdateTagRequest.prototype.clearUpdateMask = function() {
  return this.setUpdateMask(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.legebill.site.tag.v4.UpdateTagRequest.prototype.hasUpdateMask = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.legebill.site.tag.v4.TagUpdate.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.tag.v4.TagUpdate.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.tag.v4.TagUpdate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.tag.v4.TagUpdate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.TagUpdate.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    description: jspb.Message.getFieldWithDefault(msg, 2, ""),
    suggestionConfig: jspb.Message.getFieldWithDefault(msg, 3, 0),
    defaultActivityTypeId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    defaultTimesheetFieldValuesList: jspb.Message.toObjectList(msg.getDefaultTimesheetFieldValuesList(),
    legebill_type_tag_pb.DefaultTimesheetFieldValue.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.tag.v4.TagUpdate}
 */
proto.legebill.site.tag.v4.TagUpdate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.tag.v4.TagUpdate;
  return proto.legebill.site.tag.v4.TagUpdate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.tag.v4.TagUpdate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.tag.v4.TagUpdate}
 */
proto.legebill.site.tag.v4.TagUpdate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 3:
      var value = /** @type {!proto.legebill.type.Tag.SuggestionConfig} */ (reader.readEnum());
      msg.setSuggestionConfig(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDefaultActivityTypeId(value);
      break;
    case 5:
      var value = new legebill_type_tag_pb.DefaultTimesheetFieldValue;
      reader.readMessage(value,legebill_type_tag_pb.DefaultTimesheetFieldValue.deserializeBinaryFromReader);
      msg.addDefaultTimesheetFieldValues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.tag.v4.TagUpdate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.tag.v4.TagUpdate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.tag.v4.TagUpdate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.TagUpdate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSuggestionConfig();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getDefaultActivityTypeId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDefaultTimesheetFieldValuesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      legebill_type_tag_pb.DefaultTimesheetFieldValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.legebill.site.tag.v4.TagUpdate.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.tag.v4.TagUpdate} returns this
 */
proto.legebill.site.tag.v4.TagUpdate.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.legebill.site.tag.v4.TagUpdate.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.tag.v4.TagUpdate} returns this
 */
proto.legebill.site.tag.v4.TagUpdate.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional legebill.type.Tag.SuggestionConfig suggestion_config = 3;
 * @return {!proto.legebill.type.Tag.SuggestionConfig}
 */
proto.legebill.site.tag.v4.TagUpdate.prototype.getSuggestionConfig = function() {
  return /** @type {!proto.legebill.type.Tag.SuggestionConfig} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.legebill.type.Tag.SuggestionConfig} value
 * @return {!proto.legebill.site.tag.v4.TagUpdate} returns this
 */
proto.legebill.site.tag.v4.TagUpdate.prototype.setSuggestionConfig = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string default_activity_type_id = 4;
 * @return {string}
 */
proto.legebill.site.tag.v4.TagUpdate.prototype.getDefaultActivityTypeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.tag.v4.TagUpdate} returns this
 */
proto.legebill.site.tag.v4.TagUpdate.prototype.setDefaultActivityTypeId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated legebill.type.DefaultTimesheetFieldValue default_timesheet_field_values = 5;
 * @return {!Array<!proto.legebill.type.DefaultTimesheetFieldValue>}
 */
proto.legebill.site.tag.v4.TagUpdate.prototype.getDefaultTimesheetFieldValuesList = function() {
  return /** @type{!Array<!proto.legebill.type.DefaultTimesheetFieldValue>} */ (
    jspb.Message.getRepeatedWrapperField(this, legebill_type_tag_pb.DefaultTimesheetFieldValue, 5));
};


/**
 * @param {!Array<!proto.legebill.type.DefaultTimesheetFieldValue>} value
 * @return {!proto.legebill.site.tag.v4.TagUpdate} returns this
*/
proto.legebill.site.tag.v4.TagUpdate.prototype.setDefaultTimesheetFieldValuesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.legebill.type.DefaultTimesheetFieldValue=} opt_value
 * @param {number=} opt_index
 * @return {!proto.legebill.type.DefaultTimesheetFieldValue}
 */
proto.legebill.site.tag.v4.TagUpdate.prototype.addDefaultTimesheetFieldValues = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.legebill.type.DefaultTimesheetFieldValue, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.legebill.site.tag.v4.TagUpdate} returns this
 */
proto.legebill.site.tag.v4.TagUpdate.prototype.clearDefaultTimesheetFieldValuesList = function() {
  return this.setDefaultTimesheetFieldValuesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.tag.v4.ListTagsByCategoryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.tag.v4.ListTagsByCategoryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.tag.v4.ListTagsByCategoryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.ListTagsByCategoryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    tagCategoryId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.tag.v4.ListTagsByCategoryRequest}
 */
proto.legebill.site.tag.v4.ListTagsByCategoryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.tag.v4.ListTagsByCategoryRequest;
  return proto.legebill.site.tag.v4.ListTagsByCategoryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.tag.v4.ListTagsByCategoryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.tag.v4.ListTagsByCategoryRequest}
 */
proto.legebill.site.tag.v4.ListTagsByCategoryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTagCategoryId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.tag.v4.ListTagsByCategoryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.tag.v4.ListTagsByCategoryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.tag.v4.ListTagsByCategoryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.ListTagsByCategoryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTagCategoryId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string tag_category_id = 1;
 * @return {string}
 */
proto.legebill.site.tag.v4.ListTagsByCategoryRequest.prototype.getTagCategoryId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.tag.v4.ListTagsByCategoryRequest} returns this
 */
proto.legebill.site.tag.v4.ListTagsByCategoryRequest.prototype.setTagCategoryId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.legebill.site.tag.v4.ListTagsByCategoryResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.tag.v4.ListTagsByCategoryResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.tag.v4.ListTagsByCategoryResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.tag.v4.ListTagsByCategoryResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.ListTagsByCategoryResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    tagsList: jspb.Message.toObjectList(msg.getTagsList(),
    legebill_type_tag_pb.Tag.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.tag.v4.ListTagsByCategoryResponse}
 */
proto.legebill.site.tag.v4.ListTagsByCategoryResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.tag.v4.ListTagsByCategoryResponse;
  return proto.legebill.site.tag.v4.ListTagsByCategoryResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.tag.v4.ListTagsByCategoryResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.tag.v4.ListTagsByCategoryResponse}
 */
proto.legebill.site.tag.v4.ListTagsByCategoryResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new legebill_type_tag_pb.Tag;
      reader.readMessage(value,legebill_type_tag_pb.Tag.deserializeBinaryFromReader);
      msg.addTags(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.tag.v4.ListTagsByCategoryResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.tag.v4.ListTagsByCategoryResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.tag.v4.ListTagsByCategoryResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.ListTagsByCategoryResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      legebill_type_tag_pb.Tag.serializeBinaryToWriter
    );
  }
};


/**
 * repeated legebill.type.Tag tags = 1;
 * @return {!Array<!proto.legebill.type.Tag>}
 */
proto.legebill.site.tag.v4.ListTagsByCategoryResponse.prototype.getTagsList = function() {
  return /** @type{!Array<!proto.legebill.type.Tag>} */ (
    jspb.Message.getRepeatedWrapperField(this, legebill_type_tag_pb.Tag, 1));
};


/**
 * @param {!Array<!proto.legebill.type.Tag>} value
 * @return {!proto.legebill.site.tag.v4.ListTagsByCategoryResponse} returns this
*/
proto.legebill.site.tag.v4.ListTagsByCategoryResponse.prototype.setTagsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.legebill.type.Tag=} opt_value
 * @param {number=} opt_index
 * @return {!proto.legebill.type.Tag}
 */
proto.legebill.site.tag.v4.ListTagsByCategoryResponse.prototype.addTags = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.legebill.type.Tag, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.legebill.site.tag.v4.ListTagsByCategoryResponse} returns this
 */
proto.legebill.site.tag.v4.ListTagsByCategoryResponse.prototype.clearTagsList = function() {
  return this.setTagsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.legebill.site.tag.v4.BatchListTagsByCategoriesRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.tag.v4.BatchListTagsByCategoriesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.tag.v4.BatchListTagsByCategoriesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.tag.v4.BatchListTagsByCategoriesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.BatchListTagsByCategoriesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    tagCategoryIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.tag.v4.BatchListTagsByCategoriesRequest}
 */
proto.legebill.site.tag.v4.BatchListTagsByCategoriesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.tag.v4.BatchListTagsByCategoriesRequest;
  return proto.legebill.site.tag.v4.BatchListTagsByCategoriesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.tag.v4.BatchListTagsByCategoriesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.tag.v4.BatchListTagsByCategoriesRequest}
 */
proto.legebill.site.tag.v4.BatchListTagsByCategoriesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addTagCategoryIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.tag.v4.BatchListTagsByCategoriesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.tag.v4.BatchListTagsByCategoriesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.tag.v4.BatchListTagsByCategoriesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.BatchListTagsByCategoriesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTagCategoryIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string tag_category_ids = 1;
 * @return {!Array<string>}
 */
proto.legebill.site.tag.v4.BatchListTagsByCategoriesRequest.prototype.getTagCategoryIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.legebill.site.tag.v4.BatchListTagsByCategoriesRequest} returns this
 */
proto.legebill.site.tag.v4.BatchListTagsByCategoriesRequest.prototype.setTagCategoryIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.legebill.site.tag.v4.BatchListTagsByCategoriesRequest} returns this
 */
proto.legebill.site.tag.v4.BatchListTagsByCategoriesRequest.prototype.addTagCategoryIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.legebill.site.tag.v4.BatchListTagsByCategoriesRequest} returns this
 */
proto.legebill.site.tag.v4.BatchListTagsByCategoriesRequest.prototype.clearTagCategoryIdsList = function() {
  return this.setTagCategoryIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.legebill.site.tag.v4.BatchListTagsByCategoriesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.tag.v4.BatchListTagsByCategoriesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.tag.v4.BatchListTagsByCategoriesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.tag.v4.BatchListTagsByCategoriesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.BatchListTagsByCategoriesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    tagsByCategoriesList: jspb.Message.toObjectList(msg.getTagsByCategoriesList(),
    proto.legebill.site.tag.v4.TagCategoryMembership.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.tag.v4.BatchListTagsByCategoriesResponse}
 */
proto.legebill.site.tag.v4.BatchListTagsByCategoriesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.tag.v4.BatchListTagsByCategoriesResponse;
  return proto.legebill.site.tag.v4.BatchListTagsByCategoriesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.tag.v4.BatchListTagsByCategoriesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.tag.v4.BatchListTagsByCategoriesResponse}
 */
proto.legebill.site.tag.v4.BatchListTagsByCategoriesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.legebill.site.tag.v4.TagCategoryMembership;
      reader.readMessage(value,proto.legebill.site.tag.v4.TagCategoryMembership.deserializeBinaryFromReader);
      msg.addTagsByCategories(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.tag.v4.BatchListTagsByCategoriesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.tag.v4.BatchListTagsByCategoriesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.tag.v4.BatchListTagsByCategoriesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.BatchListTagsByCategoriesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTagsByCategoriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.legebill.site.tag.v4.TagCategoryMembership.serializeBinaryToWriter
    );
  }
};


/**
 * repeated TagCategoryMembership tags_by_categories = 1;
 * @return {!Array<!proto.legebill.site.tag.v4.TagCategoryMembership>}
 */
proto.legebill.site.tag.v4.BatchListTagsByCategoriesResponse.prototype.getTagsByCategoriesList = function() {
  return /** @type{!Array<!proto.legebill.site.tag.v4.TagCategoryMembership>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.legebill.site.tag.v4.TagCategoryMembership, 1));
};


/**
 * @param {!Array<!proto.legebill.site.tag.v4.TagCategoryMembership>} value
 * @return {!proto.legebill.site.tag.v4.BatchListTagsByCategoriesResponse} returns this
*/
proto.legebill.site.tag.v4.BatchListTagsByCategoriesResponse.prototype.setTagsByCategoriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.legebill.site.tag.v4.TagCategoryMembership=} opt_value
 * @param {number=} opt_index
 * @return {!proto.legebill.site.tag.v4.TagCategoryMembership}
 */
proto.legebill.site.tag.v4.BatchListTagsByCategoriesResponse.prototype.addTagsByCategories = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.legebill.site.tag.v4.TagCategoryMembership, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.legebill.site.tag.v4.BatchListTagsByCategoriesResponse} returns this
 */
proto.legebill.site.tag.v4.BatchListTagsByCategoriesResponse.prototype.clearTagsByCategoriesList = function() {
  return this.setTagsByCategoriesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.legebill.site.tag.v4.TagCategoryMembership.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.tag.v4.TagCategoryMembership.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.tag.v4.TagCategoryMembership.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.tag.v4.TagCategoryMembership} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.TagCategoryMembership.toObject = function(includeInstance, msg) {
  var f, obj = {
    tagCategoryId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    tagsList: jspb.Message.toObjectList(msg.getTagsList(),
    legebill_type_tag_pb.Tag.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.tag.v4.TagCategoryMembership}
 */
proto.legebill.site.tag.v4.TagCategoryMembership.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.tag.v4.TagCategoryMembership;
  return proto.legebill.site.tag.v4.TagCategoryMembership.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.tag.v4.TagCategoryMembership} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.tag.v4.TagCategoryMembership}
 */
proto.legebill.site.tag.v4.TagCategoryMembership.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTagCategoryId(value);
      break;
    case 2:
      var value = new legebill_type_tag_pb.Tag;
      reader.readMessage(value,legebill_type_tag_pb.Tag.deserializeBinaryFromReader);
      msg.addTags(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.tag.v4.TagCategoryMembership.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.tag.v4.TagCategoryMembership.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.tag.v4.TagCategoryMembership} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.TagCategoryMembership.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTagCategoryId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      legebill_type_tag_pb.Tag.serializeBinaryToWriter
    );
  }
};


/**
 * optional string tag_category_id = 1;
 * @return {string}
 */
proto.legebill.site.tag.v4.TagCategoryMembership.prototype.getTagCategoryId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.tag.v4.TagCategoryMembership} returns this
 */
proto.legebill.site.tag.v4.TagCategoryMembership.prototype.setTagCategoryId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated legebill.type.Tag tags = 2;
 * @return {!Array<!proto.legebill.type.Tag>}
 */
proto.legebill.site.tag.v4.TagCategoryMembership.prototype.getTagsList = function() {
  return /** @type{!Array<!proto.legebill.type.Tag>} */ (
    jspb.Message.getRepeatedWrapperField(this, legebill_type_tag_pb.Tag, 2));
};


/**
 * @param {!Array<!proto.legebill.type.Tag>} value
 * @return {!proto.legebill.site.tag.v4.TagCategoryMembership} returns this
*/
proto.legebill.site.tag.v4.TagCategoryMembership.prototype.setTagsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.legebill.type.Tag=} opt_value
 * @param {number=} opt_index
 * @return {!proto.legebill.type.Tag}
 */
proto.legebill.site.tag.v4.TagCategoryMembership.prototype.addTags = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.legebill.type.Tag, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.legebill.site.tag.v4.TagCategoryMembership} returns this
 */
proto.legebill.site.tag.v4.TagCategoryMembership.prototype.clearTagsList = function() {
  return this.setTagsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.tag.v4.ListTagsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.tag.v4.ListTagsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.tag.v4.ListTagsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.ListTagsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    pageSize: jspb.Message.getFieldWithDefault(msg, 2, 0),
    resultsOffset: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.tag.v4.ListTagsRequest}
 */
proto.legebill.site.tag.v4.ListTagsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.tag.v4.ListTagsRequest;
  return proto.legebill.site.tag.v4.ListTagsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.tag.v4.ListTagsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.tag.v4.ListTagsRequest}
 */
proto.legebill.site.tag.v4.ListTagsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setResultsOffset(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.tag.v4.ListTagsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.tag.v4.ListTagsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.tag.v4.ListTagsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.ListTagsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getResultsOffset();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
};


/**
 * optional string site_id = 1;
 * @return {string}
 */
proto.legebill.site.tag.v4.ListTagsRequest.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.tag.v4.ListTagsRequest} returns this
 */
proto.legebill.site.tag.v4.ListTagsRequest.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint32 page_size = 2;
 * @return {number}
 */
proto.legebill.site.tag.v4.ListTagsRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.legebill.site.tag.v4.ListTagsRequest} returns this
 */
proto.legebill.site.tag.v4.ListTagsRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 results_offset = 3;
 * @return {number}
 */
proto.legebill.site.tag.v4.ListTagsRequest.prototype.getResultsOffset = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.legebill.site.tag.v4.ListTagsRequest} returns this
 */
proto.legebill.site.tag.v4.ListTagsRequest.prototype.setResultsOffset = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.legebill.site.tag.v4.ListTagsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.tag.v4.ListTagsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.tag.v4.ListTagsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.tag.v4.ListTagsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.ListTagsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    tagsList: jspb.Message.toObjectList(msg.getTagsList(),
    legebill_type_tag_pb.Tag.toObject, includeInstance),
    resultsCount: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.tag.v4.ListTagsResponse}
 */
proto.legebill.site.tag.v4.ListTagsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.tag.v4.ListTagsResponse;
  return proto.legebill.site.tag.v4.ListTagsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.tag.v4.ListTagsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.tag.v4.ListTagsResponse}
 */
proto.legebill.site.tag.v4.ListTagsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new legebill_type_tag_pb.Tag;
      reader.readMessage(value,legebill_type_tag_pb.Tag.deserializeBinaryFromReader);
      msg.addTags(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setResultsCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.tag.v4.ListTagsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.tag.v4.ListTagsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.tag.v4.ListTagsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.ListTagsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      legebill_type_tag_pb.Tag.serializeBinaryToWriter
    );
  }
  f = message.getResultsCount();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
};


/**
 * repeated legebill.type.Tag tags = 1;
 * @return {!Array<!proto.legebill.type.Tag>}
 */
proto.legebill.site.tag.v4.ListTagsResponse.prototype.getTagsList = function() {
  return /** @type{!Array<!proto.legebill.type.Tag>} */ (
    jspb.Message.getRepeatedWrapperField(this, legebill_type_tag_pb.Tag, 1));
};


/**
 * @param {!Array<!proto.legebill.type.Tag>} value
 * @return {!proto.legebill.site.tag.v4.ListTagsResponse} returns this
*/
proto.legebill.site.tag.v4.ListTagsResponse.prototype.setTagsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.legebill.type.Tag=} opt_value
 * @param {number=} opt_index
 * @return {!proto.legebill.type.Tag}
 */
proto.legebill.site.tag.v4.ListTagsResponse.prototype.addTags = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.legebill.type.Tag, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.legebill.site.tag.v4.ListTagsResponse} returns this
 */
proto.legebill.site.tag.v4.ListTagsResponse.prototype.clearTagsList = function() {
  return this.setTagsList([]);
};


/**
 * optional uint64 results_count = 2;
 * @return {number}
 */
proto.legebill.site.tag.v4.ListTagsResponse.prototype.getResultsCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.legebill.site.tag.v4.ListTagsResponse} returns this
 */
proto.legebill.site.tag.v4.ListTagsResponse.prototype.setResultsCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.tag.v4.DeleteAllConnectorTagsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.tag.v4.DeleteAllConnectorTagsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.tag.v4.DeleteAllConnectorTagsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.DeleteAllConnectorTagsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.tag.v4.DeleteAllConnectorTagsRequest}
 */
proto.legebill.site.tag.v4.DeleteAllConnectorTagsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.tag.v4.DeleteAllConnectorTagsRequest;
  return proto.legebill.site.tag.v4.DeleteAllConnectorTagsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.tag.v4.DeleteAllConnectorTagsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.tag.v4.DeleteAllConnectorTagsRequest}
 */
proto.legebill.site.tag.v4.DeleteAllConnectorTagsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.tag.v4.DeleteAllConnectorTagsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.tag.v4.DeleteAllConnectorTagsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.tag.v4.DeleteAllConnectorTagsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.DeleteAllConnectorTagsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string site_id = 1;
 * @return {string}
 */
proto.legebill.site.tag.v4.DeleteAllConnectorTagsRequest.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.tag.v4.DeleteAllConnectorTagsRequest} returns this
 */
proto.legebill.site.tag.v4.DeleteAllConnectorTagsRequest.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.tag.v4.SearchTagsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.tag.v4.SearchTagsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.tag.v4.SearchTagsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.SearchTagsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    searchText: jspb.Message.getFieldWithDefault(msg, 2, ""),
    pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0),
    pageToken: jspb.Message.getFieldWithDefault(msg, 5, ""),
    orderBy: jspb.Message.getFieldWithDefault(msg, 4, 0),
    source: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.tag.v4.SearchTagsRequest}
 */
proto.legebill.site.tag.v4.SearchTagsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.tag.v4.SearchTagsRequest;
  return proto.legebill.site.tag.v4.SearchTagsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.tag.v4.SearchTagsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.tag.v4.SearchTagsRequest}
 */
proto.legebill.site.tag.v4.SearchTagsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSearchText(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPageToken(value);
      break;
    case 4:
      var value = /** @type {!proto.legebill.site.tag.v4.SearchTagsRequest.OrderBy} */ (reader.readEnum());
      msg.setOrderBy(value);
      break;
    case 6:
      var value = /** @type {!proto.legebill.type.Tag.Source} */ (reader.readEnum());
      msg.setSource(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.tag.v4.SearchTagsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.tag.v4.SearchTagsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.tag.v4.SearchTagsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.SearchTagsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSearchText();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getPageToken();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getOrderBy();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getSource();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.legebill.site.tag.v4.SearchTagsRequest.OrderBy = {
  ORDER_BY_UNSPECIFIED: 0,
  RELEVANCE: 1,
  NAME: 2
};

/**
 * optional string site_id = 1;
 * @return {string}
 */
proto.legebill.site.tag.v4.SearchTagsRequest.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.tag.v4.SearchTagsRequest} returns this
 */
proto.legebill.site.tag.v4.SearchTagsRequest.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string search_text = 2;
 * @return {string}
 */
proto.legebill.site.tag.v4.SearchTagsRequest.prototype.getSearchText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.tag.v4.SearchTagsRequest} returns this
 */
proto.legebill.site.tag.v4.SearchTagsRequest.prototype.setSearchText = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 page_size = 3;
 * @return {number}
 */
proto.legebill.site.tag.v4.SearchTagsRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.legebill.site.tag.v4.SearchTagsRequest} returns this
 */
proto.legebill.site.tag.v4.SearchTagsRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string page_token = 5;
 * @return {string}
 */
proto.legebill.site.tag.v4.SearchTagsRequest.prototype.getPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.tag.v4.SearchTagsRequest} returns this
 */
proto.legebill.site.tag.v4.SearchTagsRequest.prototype.setPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional OrderBy order_by = 4;
 * @return {!proto.legebill.site.tag.v4.SearchTagsRequest.OrderBy}
 */
proto.legebill.site.tag.v4.SearchTagsRequest.prototype.getOrderBy = function() {
  return /** @type {!proto.legebill.site.tag.v4.SearchTagsRequest.OrderBy} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.legebill.site.tag.v4.SearchTagsRequest.OrderBy} value
 * @return {!proto.legebill.site.tag.v4.SearchTagsRequest} returns this
 */
proto.legebill.site.tag.v4.SearchTagsRequest.prototype.setOrderBy = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional legebill.type.Tag.Source source = 6;
 * @return {!proto.legebill.type.Tag.Source}
 */
proto.legebill.site.tag.v4.SearchTagsRequest.prototype.getSource = function() {
  return /** @type {!proto.legebill.type.Tag.Source} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.legebill.type.Tag.Source} value
 * @return {!proto.legebill.site.tag.v4.SearchTagsRequest} returns this
 */
proto.legebill.site.tag.v4.SearchTagsRequest.prototype.setSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.legebill.site.tag.v4.SearchTagsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.tag.v4.SearchTagsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.tag.v4.SearchTagsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.tag.v4.SearchTagsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.SearchTagsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    tagsList: jspb.Message.toObjectList(msg.getTagsList(),
    legebill_type_tag_pb.Tag.toObject, includeInstance),
    resultsCount: jspb.Message.getFieldWithDefault(msg, 2, 0),
    nextPageToken: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.tag.v4.SearchTagsResponse}
 */
proto.legebill.site.tag.v4.SearchTagsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.tag.v4.SearchTagsResponse;
  return proto.legebill.site.tag.v4.SearchTagsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.tag.v4.SearchTagsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.tag.v4.SearchTagsResponse}
 */
proto.legebill.site.tag.v4.SearchTagsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new legebill_type_tag_pb.Tag;
      reader.readMessage(value,legebill_type_tag_pb.Tag.deserializeBinaryFromReader);
      msg.addTags(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setResultsCount(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.tag.v4.SearchTagsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.tag.v4.SearchTagsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.tag.v4.SearchTagsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.SearchTagsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      legebill_type_tag_pb.Tag.serializeBinaryToWriter
    );
  }
  f = message.getResultsCount();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getNextPageToken();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * repeated legebill.type.Tag tags = 1;
 * @return {!Array<!proto.legebill.type.Tag>}
 */
proto.legebill.site.tag.v4.SearchTagsResponse.prototype.getTagsList = function() {
  return /** @type{!Array<!proto.legebill.type.Tag>} */ (
    jspb.Message.getRepeatedWrapperField(this, legebill_type_tag_pb.Tag, 1));
};


/**
 * @param {!Array<!proto.legebill.type.Tag>} value
 * @return {!proto.legebill.site.tag.v4.SearchTagsResponse} returns this
*/
proto.legebill.site.tag.v4.SearchTagsResponse.prototype.setTagsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.legebill.type.Tag=} opt_value
 * @param {number=} opt_index
 * @return {!proto.legebill.type.Tag}
 */
proto.legebill.site.tag.v4.SearchTagsResponse.prototype.addTags = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.legebill.type.Tag, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.legebill.site.tag.v4.SearchTagsResponse} returns this
 */
proto.legebill.site.tag.v4.SearchTagsResponse.prototype.clearTagsList = function() {
  return this.setTagsList([]);
};


/**
 * optional uint64 results_count = 2;
 * @return {number}
 */
proto.legebill.site.tag.v4.SearchTagsResponse.prototype.getResultsCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.legebill.site.tag.v4.SearchTagsResponse} returns this
 */
proto.legebill.site.tag.v4.SearchTagsResponse.prototype.setResultsCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string next_page_token = 3;
 * @return {string}
 */
proto.legebill.site.tag.v4.SearchTagsResponse.prototype.getNextPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.tag.v4.SearchTagsResponse} returns this
 */
proto.legebill.site.tag.v4.SearchTagsResponse.prototype.setNextPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.legebill.site.tag.v4.SearchTagsResponseShallow.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.tag.v4.SearchTagsResponseShallow.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.tag.v4.SearchTagsResponseShallow.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.tag.v4.SearchTagsResponseShallow} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.SearchTagsResponseShallow.toObject = function(includeInstance, msg) {
  var f, obj = {
    tagsShallowList: jspb.Message.toObjectList(msg.getTagsShallowList(),
    legebill_type_tag_pb.TagShallow.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.tag.v4.SearchTagsResponseShallow}
 */
proto.legebill.site.tag.v4.SearchTagsResponseShallow.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.tag.v4.SearchTagsResponseShallow;
  return proto.legebill.site.tag.v4.SearchTagsResponseShallow.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.tag.v4.SearchTagsResponseShallow} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.tag.v4.SearchTagsResponseShallow}
 */
proto.legebill.site.tag.v4.SearchTagsResponseShallow.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new legebill_type_tag_pb.TagShallow;
      reader.readMessage(value,legebill_type_tag_pb.TagShallow.deserializeBinaryFromReader);
      msg.addTagsShallow(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.tag.v4.SearchTagsResponseShallow.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.tag.v4.SearchTagsResponseShallow.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.tag.v4.SearchTagsResponseShallow} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.SearchTagsResponseShallow.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTagsShallowList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      legebill_type_tag_pb.TagShallow.serializeBinaryToWriter
    );
  }
};


/**
 * repeated legebill.type.TagShallow tags_shallow = 1;
 * @return {!Array<!proto.legebill.type.TagShallow>}
 */
proto.legebill.site.tag.v4.SearchTagsResponseShallow.prototype.getTagsShallowList = function() {
  return /** @type{!Array<!proto.legebill.type.TagShallow>} */ (
    jspb.Message.getRepeatedWrapperField(this, legebill_type_tag_pb.TagShallow, 1));
};


/**
 * @param {!Array<!proto.legebill.type.TagShallow>} value
 * @return {!proto.legebill.site.tag.v4.SearchTagsResponseShallow} returns this
*/
proto.legebill.site.tag.v4.SearchTagsResponseShallow.prototype.setTagsShallowList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.legebill.type.TagShallow=} opt_value
 * @param {number=} opt_index
 * @return {!proto.legebill.type.TagShallow}
 */
proto.legebill.site.tag.v4.SearchTagsResponseShallow.prototype.addTagsShallow = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.legebill.type.TagShallow, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.legebill.site.tag.v4.SearchTagsResponseShallow} returns this
 */
proto.legebill.site.tag.v4.SearchTagsResponseShallow.prototype.clearTagsShallowList = function() {
  return this.setTagsShallowList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.legebill.site.tag.v4.BatchGetTagsRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.tag.v4.BatchGetTagsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.tag.v4.BatchGetTagsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.tag.v4.BatchGetTagsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.BatchGetTagsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    tagIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.tag.v4.BatchGetTagsRequest}
 */
proto.legebill.site.tag.v4.BatchGetTagsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.tag.v4.BatchGetTagsRequest;
  return proto.legebill.site.tag.v4.BatchGetTagsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.tag.v4.BatchGetTagsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.tag.v4.BatchGetTagsRequest}
 */
proto.legebill.site.tag.v4.BatchGetTagsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addTagIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.tag.v4.BatchGetTagsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.tag.v4.BatchGetTagsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.tag.v4.BatchGetTagsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.BatchGetTagsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTagIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string tag_ids = 1;
 * @return {!Array<string>}
 */
proto.legebill.site.tag.v4.BatchGetTagsRequest.prototype.getTagIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.legebill.site.tag.v4.BatchGetTagsRequest} returns this
 */
proto.legebill.site.tag.v4.BatchGetTagsRequest.prototype.setTagIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.legebill.site.tag.v4.BatchGetTagsRequest} returns this
 */
proto.legebill.site.tag.v4.BatchGetTagsRequest.prototype.addTagIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.legebill.site.tag.v4.BatchGetTagsRequest} returns this
 */
proto.legebill.site.tag.v4.BatchGetTagsRequest.prototype.clearTagIdsList = function() {
  return this.setTagIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.legebill.site.tag.v4.BatchGetTagsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.tag.v4.BatchGetTagsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.tag.v4.BatchGetTagsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.tag.v4.BatchGetTagsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.BatchGetTagsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    tagsList: jspb.Message.toObjectList(msg.getTagsList(),
    legebill_type_tag_pb.Tag.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.tag.v4.BatchGetTagsResponse}
 */
proto.legebill.site.tag.v4.BatchGetTagsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.tag.v4.BatchGetTagsResponse;
  return proto.legebill.site.tag.v4.BatchGetTagsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.tag.v4.BatchGetTagsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.tag.v4.BatchGetTagsResponse}
 */
proto.legebill.site.tag.v4.BatchGetTagsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new legebill_type_tag_pb.Tag;
      reader.readMessage(value,legebill_type_tag_pb.Tag.deserializeBinaryFromReader);
      msg.addTags(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.tag.v4.BatchGetTagsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.tag.v4.BatchGetTagsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.tag.v4.BatchGetTagsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.BatchGetTagsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      legebill_type_tag_pb.Tag.serializeBinaryToWriter
    );
  }
};


/**
 * repeated legebill.type.Tag tags = 1;
 * @return {!Array<!proto.legebill.type.Tag>}
 */
proto.legebill.site.tag.v4.BatchGetTagsResponse.prototype.getTagsList = function() {
  return /** @type{!Array<!proto.legebill.type.Tag>} */ (
    jspb.Message.getRepeatedWrapperField(this, legebill_type_tag_pb.Tag, 1));
};


/**
 * @param {!Array<!proto.legebill.type.Tag>} value
 * @return {!proto.legebill.site.tag.v4.BatchGetTagsResponse} returns this
*/
proto.legebill.site.tag.v4.BatchGetTagsResponse.prototype.setTagsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.legebill.type.Tag=} opt_value
 * @param {number=} opt_index
 * @return {!proto.legebill.type.Tag}
 */
proto.legebill.site.tag.v4.BatchGetTagsResponse.prototype.addTags = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.legebill.type.Tag, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.legebill.site.tag.v4.BatchGetTagsResponse} returns this
 */
proto.legebill.site.tag.v4.BatchGetTagsResponse.prototype.clearTagsList = function() {
  return this.setTagsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.legebill.site.tag.v4.CreateTagRequest.repeatedFields_ = [4,7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.tag.v4.CreateTagRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.tag.v4.CreateTagRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.tag.v4.CreateTagRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.CreateTagRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    description: jspb.Message.getFieldWithDefault(msg, 3, ""),
    keywordsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    defaultActivityTypeId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    suggestionConfig: jspb.Message.getFieldWithDefault(msg, 6, 0),
    defaultTimesheetFieldValuesList: jspb.Message.toObjectList(msg.getDefaultTimesheetFieldValuesList(),
    legebill_type_tag_pb.DefaultTimesheetFieldValue.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.tag.v4.CreateTagRequest}
 */
proto.legebill.site.tag.v4.CreateTagRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.tag.v4.CreateTagRequest;
  return proto.legebill.site.tag.v4.CreateTagRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.tag.v4.CreateTagRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.tag.v4.CreateTagRequest}
 */
proto.legebill.site.tag.v4.CreateTagRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addKeywords(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDefaultActivityTypeId(value);
      break;
    case 6:
      var value = /** @type {!proto.legebill.type.Tag.SuggestionConfig} */ (reader.readEnum());
      msg.setSuggestionConfig(value);
      break;
    case 7:
      var value = new legebill_type_tag_pb.DefaultTimesheetFieldValue;
      reader.readMessage(value,legebill_type_tag_pb.DefaultTimesheetFieldValue.deserializeBinaryFromReader);
      msg.addDefaultTimesheetFieldValues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.tag.v4.CreateTagRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.tag.v4.CreateTagRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.tag.v4.CreateTagRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.CreateTagRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getKeywordsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getDefaultActivityTypeId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSuggestionConfig();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getDefaultTimesheetFieldValuesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      legebill_type_tag_pb.DefaultTimesheetFieldValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string site_id = 1;
 * @return {string}
 */
proto.legebill.site.tag.v4.CreateTagRequest.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.tag.v4.CreateTagRequest} returns this
 */
proto.legebill.site.tag.v4.CreateTagRequest.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.legebill.site.tag.v4.CreateTagRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.tag.v4.CreateTagRequest} returns this
 */
proto.legebill.site.tag.v4.CreateTagRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.legebill.site.tag.v4.CreateTagRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.tag.v4.CreateTagRequest} returns this
 */
proto.legebill.site.tag.v4.CreateTagRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated string keywords = 4;
 * @return {!Array<string>}
 */
proto.legebill.site.tag.v4.CreateTagRequest.prototype.getKeywordsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.legebill.site.tag.v4.CreateTagRequest} returns this
 */
proto.legebill.site.tag.v4.CreateTagRequest.prototype.setKeywordsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.legebill.site.tag.v4.CreateTagRequest} returns this
 */
proto.legebill.site.tag.v4.CreateTagRequest.prototype.addKeywords = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.legebill.site.tag.v4.CreateTagRequest} returns this
 */
proto.legebill.site.tag.v4.CreateTagRequest.prototype.clearKeywordsList = function() {
  return this.setKeywordsList([]);
};


/**
 * optional string default_activity_type_id = 5;
 * @return {string}
 */
proto.legebill.site.tag.v4.CreateTagRequest.prototype.getDefaultActivityTypeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.tag.v4.CreateTagRequest} returns this
 */
proto.legebill.site.tag.v4.CreateTagRequest.prototype.setDefaultActivityTypeId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional legebill.type.Tag.SuggestionConfig suggestion_config = 6;
 * @return {!proto.legebill.type.Tag.SuggestionConfig}
 */
proto.legebill.site.tag.v4.CreateTagRequest.prototype.getSuggestionConfig = function() {
  return /** @type {!proto.legebill.type.Tag.SuggestionConfig} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.legebill.type.Tag.SuggestionConfig} value
 * @return {!proto.legebill.site.tag.v4.CreateTagRequest} returns this
 */
proto.legebill.site.tag.v4.CreateTagRequest.prototype.setSuggestionConfig = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * repeated legebill.type.DefaultTimesheetFieldValue default_timesheet_field_values = 7;
 * @return {!Array<!proto.legebill.type.DefaultTimesheetFieldValue>}
 */
proto.legebill.site.tag.v4.CreateTagRequest.prototype.getDefaultTimesheetFieldValuesList = function() {
  return /** @type{!Array<!proto.legebill.type.DefaultTimesheetFieldValue>} */ (
    jspb.Message.getRepeatedWrapperField(this, legebill_type_tag_pb.DefaultTimesheetFieldValue, 7));
};


/**
 * @param {!Array<!proto.legebill.type.DefaultTimesheetFieldValue>} value
 * @return {!proto.legebill.site.tag.v4.CreateTagRequest} returns this
*/
proto.legebill.site.tag.v4.CreateTagRequest.prototype.setDefaultTimesheetFieldValuesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.legebill.type.DefaultTimesheetFieldValue=} opt_value
 * @param {number=} opt_index
 * @return {!proto.legebill.type.DefaultTimesheetFieldValue}
 */
proto.legebill.site.tag.v4.CreateTagRequest.prototype.addDefaultTimesheetFieldValues = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.legebill.type.DefaultTimesheetFieldValue, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.legebill.site.tag.v4.CreateTagRequest} returns this
 */
proto.legebill.site.tag.v4.CreateTagRequest.prototype.clearDefaultTimesheetFieldValuesList = function() {
  return this.setDefaultTimesheetFieldValuesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.tag.v4.CreateTagKeywordRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.tag.v4.CreateTagKeywordRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.tag.v4.CreateTagKeywordRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.CreateTagKeywordRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    keyword: (f = msg.getKeyword()) && legebill_type_tag_pb.TagKeyword.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.tag.v4.CreateTagKeywordRequest}
 */
proto.legebill.site.tag.v4.CreateTagKeywordRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.tag.v4.CreateTagKeywordRequest;
  return proto.legebill.site.tag.v4.CreateTagKeywordRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.tag.v4.CreateTagKeywordRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.tag.v4.CreateTagKeywordRequest}
 */
proto.legebill.site.tag.v4.CreateTagKeywordRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new legebill_type_tag_pb.TagKeyword;
      reader.readMessage(value,legebill_type_tag_pb.TagKeyword.deserializeBinaryFromReader);
      msg.setKeyword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.tag.v4.CreateTagKeywordRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.tag.v4.CreateTagKeywordRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.tag.v4.CreateTagKeywordRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.CreateTagKeywordRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKeyword();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      legebill_type_tag_pb.TagKeyword.serializeBinaryToWriter
    );
  }
};


/**
 * optional legebill.type.TagKeyword keyword = 1;
 * @return {?proto.legebill.type.TagKeyword}
 */
proto.legebill.site.tag.v4.CreateTagKeywordRequest.prototype.getKeyword = function() {
  return /** @type{?proto.legebill.type.TagKeyword} */ (
    jspb.Message.getWrapperField(this, legebill_type_tag_pb.TagKeyword, 1));
};


/**
 * @param {?proto.legebill.type.TagKeyword|undefined} value
 * @return {!proto.legebill.site.tag.v4.CreateTagKeywordRequest} returns this
*/
proto.legebill.site.tag.v4.CreateTagKeywordRequest.prototype.setKeyword = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.legebill.site.tag.v4.CreateTagKeywordRequest} returns this
 */
proto.legebill.site.tag.v4.CreateTagKeywordRequest.prototype.clearKeyword = function() {
  return this.setKeyword(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.legebill.site.tag.v4.CreateTagKeywordRequest.prototype.hasKeyword = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.tag.v4.DeleteTagKeywordRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.tag.v4.DeleteTagKeywordRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.tag.v4.DeleteTagKeywordRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.DeleteTagKeywordRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    keyword: (f = msg.getKeyword()) && legebill_type_tag_pb.TagKeyword.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.tag.v4.DeleteTagKeywordRequest}
 */
proto.legebill.site.tag.v4.DeleteTagKeywordRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.tag.v4.DeleteTagKeywordRequest;
  return proto.legebill.site.tag.v4.DeleteTagKeywordRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.tag.v4.DeleteTagKeywordRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.tag.v4.DeleteTagKeywordRequest}
 */
proto.legebill.site.tag.v4.DeleteTagKeywordRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new legebill_type_tag_pb.TagKeyword;
      reader.readMessage(value,legebill_type_tag_pb.TagKeyword.deserializeBinaryFromReader);
      msg.setKeyword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.tag.v4.DeleteTagKeywordRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.tag.v4.DeleteTagKeywordRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.tag.v4.DeleteTagKeywordRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.DeleteTagKeywordRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKeyword();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      legebill_type_tag_pb.TagKeyword.serializeBinaryToWriter
    );
  }
};


/**
 * optional legebill.type.TagKeyword keyword = 1;
 * @return {?proto.legebill.type.TagKeyword}
 */
proto.legebill.site.tag.v4.DeleteTagKeywordRequest.prototype.getKeyword = function() {
  return /** @type{?proto.legebill.type.TagKeyword} */ (
    jspb.Message.getWrapperField(this, legebill_type_tag_pb.TagKeyword, 1));
};


/**
 * @param {?proto.legebill.type.TagKeyword|undefined} value
 * @return {!proto.legebill.site.tag.v4.DeleteTagKeywordRequest} returns this
*/
proto.legebill.site.tag.v4.DeleteTagKeywordRequest.prototype.setKeyword = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.legebill.site.tag.v4.DeleteTagKeywordRequest} returns this
 */
proto.legebill.site.tag.v4.DeleteTagKeywordRequest.prototype.clearKeyword = function() {
  return this.setKeyword(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.legebill.site.tag.v4.DeleteTagKeywordRequest.prototype.hasKeyword = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.tag.v4.ListFavouriteTagsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.tag.v4.ListFavouriteTagsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.tag.v4.ListFavouriteTagsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.ListFavouriteTagsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.tag.v4.ListFavouriteTagsRequest}
 */
proto.legebill.site.tag.v4.ListFavouriteTagsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.tag.v4.ListFavouriteTagsRequest;
  return proto.legebill.site.tag.v4.ListFavouriteTagsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.tag.v4.ListFavouriteTagsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.tag.v4.ListFavouriteTagsRequest}
 */
proto.legebill.site.tag.v4.ListFavouriteTagsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.tag.v4.ListFavouriteTagsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.tag.v4.ListFavouriteTagsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.tag.v4.ListFavouriteTagsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.ListFavouriteTagsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string site_id = 1;
 * @return {string}
 */
proto.legebill.site.tag.v4.ListFavouriteTagsRequest.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.tag.v4.ListFavouriteTagsRequest} returns this
 */
proto.legebill.site.tag.v4.ListFavouriteTagsRequest.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.legebill.site.tag.v4.ListFavouriteTagsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.tag.v4.ListFavouriteTagsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.tag.v4.ListFavouriteTagsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.tag.v4.ListFavouriteTagsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.ListFavouriteTagsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    favouriteTagsList: jspb.Message.toObjectList(msg.getFavouriteTagsList(),
    proto.legebill.site.tag.v4.FavouriteTag.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.tag.v4.ListFavouriteTagsResponse}
 */
proto.legebill.site.tag.v4.ListFavouriteTagsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.tag.v4.ListFavouriteTagsResponse;
  return proto.legebill.site.tag.v4.ListFavouriteTagsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.tag.v4.ListFavouriteTagsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.tag.v4.ListFavouriteTagsResponse}
 */
proto.legebill.site.tag.v4.ListFavouriteTagsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.legebill.site.tag.v4.FavouriteTag;
      reader.readMessage(value,proto.legebill.site.tag.v4.FavouriteTag.deserializeBinaryFromReader);
      msg.addFavouriteTags(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.tag.v4.ListFavouriteTagsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.tag.v4.ListFavouriteTagsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.tag.v4.ListFavouriteTagsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.ListFavouriteTagsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFavouriteTagsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.legebill.site.tag.v4.FavouriteTag.serializeBinaryToWriter
    );
  }
};


/**
 * repeated FavouriteTag favourite_tags = 1;
 * @return {!Array<!proto.legebill.site.tag.v4.FavouriteTag>}
 */
proto.legebill.site.tag.v4.ListFavouriteTagsResponse.prototype.getFavouriteTagsList = function() {
  return /** @type{!Array<!proto.legebill.site.tag.v4.FavouriteTag>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.legebill.site.tag.v4.FavouriteTag, 1));
};


/**
 * @param {!Array<!proto.legebill.site.tag.v4.FavouriteTag>} value
 * @return {!proto.legebill.site.tag.v4.ListFavouriteTagsResponse} returns this
*/
proto.legebill.site.tag.v4.ListFavouriteTagsResponse.prototype.setFavouriteTagsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.legebill.site.tag.v4.FavouriteTag=} opt_value
 * @param {number=} opt_index
 * @return {!proto.legebill.site.tag.v4.FavouriteTag}
 */
proto.legebill.site.tag.v4.ListFavouriteTagsResponse.prototype.addFavouriteTags = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.legebill.site.tag.v4.FavouriteTag, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.legebill.site.tag.v4.ListFavouriteTagsResponse} returns this
 */
proto.legebill.site.tag.v4.ListFavouriteTagsResponse.prototype.clearFavouriteTagsList = function() {
  return this.setFavouriteTagsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.tag.v4.FavouriteTag.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.tag.v4.FavouriteTag.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.tag.v4.FavouriteTag} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.FavouriteTag.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    tag: (f = msg.getTag()) && legebill_type_tag_pb.Tag.toObject(includeInstance, f),
    siteListIndex: jspb.Message.getFieldWithDefault(msg, 3, 0),
    createTime: (f = msg.getCreateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.tag.v4.FavouriteTag}
 */
proto.legebill.site.tag.v4.FavouriteTag.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.tag.v4.FavouriteTag;
  return proto.legebill.site.tag.v4.FavouriteTag.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.tag.v4.FavouriteTag} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.tag.v4.FavouriteTag}
 */
proto.legebill.site.tag.v4.FavouriteTag.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new legebill_type_tag_pb.Tag;
      reader.readMessage(value,legebill_type_tag_pb.Tag.deserializeBinaryFromReader);
      msg.setTag(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSiteListIndex(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreateTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.tag.v4.FavouriteTag.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.tag.v4.FavouriteTag.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.tag.v4.FavouriteTag} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.FavouriteTag.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTag();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      legebill_type_tag_pb.Tag.serializeBinaryToWriter
    );
  }
  f = message.getSiteListIndex();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getCreateTime();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.legebill.site.tag.v4.FavouriteTag.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.tag.v4.FavouriteTag} returns this
 */
proto.legebill.site.tag.v4.FavouriteTag.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional legebill.type.Tag tag = 2;
 * @return {?proto.legebill.type.Tag}
 */
proto.legebill.site.tag.v4.FavouriteTag.prototype.getTag = function() {
  return /** @type{?proto.legebill.type.Tag} */ (
    jspb.Message.getWrapperField(this, legebill_type_tag_pb.Tag, 2));
};


/**
 * @param {?proto.legebill.type.Tag|undefined} value
 * @return {!proto.legebill.site.tag.v4.FavouriteTag} returns this
*/
proto.legebill.site.tag.v4.FavouriteTag.prototype.setTag = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.legebill.site.tag.v4.FavouriteTag} returns this
 */
proto.legebill.site.tag.v4.FavouriteTag.prototype.clearTag = function() {
  return this.setTag(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.legebill.site.tag.v4.FavouriteTag.prototype.hasTag = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional uint32 site_list_index = 3;
 * @return {number}
 */
proto.legebill.site.tag.v4.FavouriteTag.prototype.getSiteListIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.legebill.site.tag.v4.FavouriteTag} returns this
 */
proto.legebill.site.tag.v4.FavouriteTag.prototype.setSiteListIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional google.protobuf.Timestamp create_time = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.legebill.site.tag.v4.FavouriteTag.prototype.getCreateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.legebill.site.tag.v4.FavouriteTag} returns this
*/
proto.legebill.site.tag.v4.FavouriteTag.prototype.setCreateTime = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.legebill.site.tag.v4.FavouriteTag} returns this
 */
proto.legebill.site.tag.v4.FavouriteTag.prototype.clearCreateTime = function() {
  return this.setCreateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.legebill.site.tag.v4.FavouriteTag.prototype.hasCreateTime = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.tag.v4.CreateFavouriteTagRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.tag.v4.CreateFavouriteTagRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.tag.v4.CreateFavouriteTagRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.CreateFavouriteTagRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    tagId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.tag.v4.CreateFavouriteTagRequest}
 */
proto.legebill.site.tag.v4.CreateFavouriteTagRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.tag.v4.CreateFavouriteTagRequest;
  return proto.legebill.site.tag.v4.CreateFavouriteTagRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.tag.v4.CreateFavouriteTagRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.tag.v4.CreateFavouriteTagRequest}
 */
proto.legebill.site.tag.v4.CreateFavouriteTagRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTagId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.tag.v4.CreateFavouriteTagRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.tag.v4.CreateFavouriteTagRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.tag.v4.CreateFavouriteTagRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.CreateFavouriteTagRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTagId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string tag_id = 1;
 * @return {string}
 */
proto.legebill.site.tag.v4.CreateFavouriteTagRequest.prototype.getTagId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.tag.v4.CreateFavouriteTagRequest} returns this
 */
proto.legebill.site.tag.v4.CreateFavouriteTagRequest.prototype.setTagId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.tag.v4.ReorderFavouriteTagRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.tag.v4.ReorderFavouriteTagRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.tag.v4.ReorderFavouriteTagRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.ReorderFavouriteTagRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    favouriteTagId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    siteListIndex: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.tag.v4.ReorderFavouriteTagRequest}
 */
proto.legebill.site.tag.v4.ReorderFavouriteTagRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.tag.v4.ReorderFavouriteTagRequest;
  return proto.legebill.site.tag.v4.ReorderFavouriteTagRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.tag.v4.ReorderFavouriteTagRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.tag.v4.ReorderFavouriteTagRequest}
 */
proto.legebill.site.tag.v4.ReorderFavouriteTagRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFavouriteTagId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSiteListIndex(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.tag.v4.ReorderFavouriteTagRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.tag.v4.ReorderFavouriteTagRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.tag.v4.ReorderFavouriteTagRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.ReorderFavouriteTagRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFavouriteTagId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSiteListIndex();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
};


/**
 * optional string favourite_tag_id = 1;
 * @return {string}
 */
proto.legebill.site.tag.v4.ReorderFavouriteTagRequest.prototype.getFavouriteTagId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.tag.v4.ReorderFavouriteTagRequest} returns this
 */
proto.legebill.site.tag.v4.ReorderFavouriteTagRequest.prototype.setFavouriteTagId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint32 site_list_index = 2;
 * @return {number}
 */
proto.legebill.site.tag.v4.ReorderFavouriteTagRequest.prototype.getSiteListIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.legebill.site.tag.v4.ReorderFavouriteTagRequest} returns this
 */
proto.legebill.site.tag.v4.ReorderFavouriteTagRequest.prototype.setSiteListIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.tag.v4.ReorderFavouriteTagResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.tag.v4.ReorderFavouriteTagResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.tag.v4.ReorderFavouriteTagResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.ReorderFavouriteTagResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.tag.v4.ReorderFavouriteTagResponse}
 */
proto.legebill.site.tag.v4.ReorderFavouriteTagResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.tag.v4.ReorderFavouriteTagResponse;
  return proto.legebill.site.tag.v4.ReorderFavouriteTagResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.tag.v4.ReorderFavouriteTagResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.tag.v4.ReorderFavouriteTagResponse}
 */
proto.legebill.site.tag.v4.ReorderFavouriteTagResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.tag.v4.ReorderFavouriteTagResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.tag.v4.ReorderFavouriteTagResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.tag.v4.ReorderFavouriteTagResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.ReorderFavouriteTagResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.tag.v4.DeleteFavouriteTagRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.tag.v4.DeleteFavouriteTagRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.tag.v4.DeleteFavouriteTagRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.DeleteFavouriteTagRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    favouriteTagId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.tag.v4.DeleteFavouriteTagRequest}
 */
proto.legebill.site.tag.v4.DeleteFavouriteTagRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.tag.v4.DeleteFavouriteTagRequest;
  return proto.legebill.site.tag.v4.DeleteFavouriteTagRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.tag.v4.DeleteFavouriteTagRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.tag.v4.DeleteFavouriteTagRequest}
 */
proto.legebill.site.tag.v4.DeleteFavouriteTagRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFavouriteTagId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.tag.v4.DeleteFavouriteTagRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.tag.v4.DeleteFavouriteTagRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.tag.v4.DeleteFavouriteTagRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.DeleteFavouriteTagRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFavouriteTagId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string favourite_tag_id = 1;
 * @return {string}
 */
proto.legebill.site.tag.v4.DeleteFavouriteTagRequest.prototype.getFavouriteTagId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.tag.v4.DeleteFavouriteTagRequest} returns this
 */
proto.legebill.site.tag.v4.DeleteFavouriteTagRequest.prototype.setFavouriteTagId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.tag.v4.ListRecentTagsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.tag.v4.ListRecentTagsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.tag.v4.ListRecentTagsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.ListRecentTagsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    pageSize: jspb.Message.getFieldWithDefault(msg, 2, 0),
    activityDate: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.tag.v4.ListRecentTagsRequest}
 */
proto.legebill.site.tag.v4.ListRecentTagsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.tag.v4.ListRecentTagsRequest;
  return proto.legebill.site.tag.v4.ListRecentTagsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.tag.v4.ListRecentTagsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.tag.v4.ListRecentTagsRequest}
 */
proto.legebill.site.tag.v4.ListRecentTagsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setActivityDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.tag.v4.ListRecentTagsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.tag.v4.ListRecentTagsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.tag.v4.ListRecentTagsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.ListRecentTagsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getActivityDate();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
};


/**
 * optional string site_id = 1;
 * @return {string}
 */
proto.legebill.site.tag.v4.ListRecentTagsRequest.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.tag.v4.ListRecentTagsRequest} returns this
 */
proto.legebill.site.tag.v4.ListRecentTagsRequest.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint32 page_size = 2;
 * @return {number}
 */
proto.legebill.site.tag.v4.ListRecentTagsRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.legebill.site.tag.v4.ListRecentTagsRequest} returns this
 */
proto.legebill.site.tag.v4.ListRecentTagsRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 activity_date = 3;
 * @return {number}
 */
proto.legebill.site.tag.v4.ListRecentTagsRequest.prototype.getActivityDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.legebill.site.tag.v4.ListRecentTagsRequest} returns this
 */
proto.legebill.site.tag.v4.ListRecentTagsRequest.prototype.setActivityDate = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.legebill.site.tag.v4.ListRecentTagsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.tag.v4.ListRecentTagsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.tag.v4.ListRecentTagsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.tag.v4.ListRecentTagsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.ListRecentTagsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    recentTagsList: jspb.Message.toObjectList(msg.getRecentTagsList(),
    legebill_type_tag_pb.Tag.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.tag.v4.ListRecentTagsResponse}
 */
proto.legebill.site.tag.v4.ListRecentTagsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.tag.v4.ListRecentTagsResponse;
  return proto.legebill.site.tag.v4.ListRecentTagsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.tag.v4.ListRecentTagsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.tag.v4.ListRecentTagsResponse}
 */
proto.legebill.site.tag.v4.ListRecentTagsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new legebill_type_tag_pb.Tag;
      reader.readMessage(value,legebill_type_tag_pb.Tag.deserializeBinaryFromReader);
      msg.addRecentTags(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.tag.v4.ListRecentTagsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.tag.v4.ListRecentTagsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.tag.v4.ListRecentTagsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.ListRecentTagsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRecentTagsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      legebill_type_tag_pb.Tag.serializeBinaryToWriter
    );
  }
};


/**
 * repeated legebill.type.Tag recent_tags = 1;
 * @return {!Array<!proto.legebill.type.Tag>}
 */
proto.legebill.site.tag.v4.ListRecentTagsResponse.prototype.getRecentTagsList = function() {
  return /** @type{!Array<!proto.legebill.type.Tag>} */ (
    jspb.Message.getRepeatedWrapperField(this, legebill_type_tag_pb.Tag, 1));
};


/**
 * @param {!Array<!proto.legebill.type.Tag>} value
 * @return {!proto.legebill.site.tag.v4.ListRecentTagsResponse} returns this
*/
proto.legebill.site.tag.v4.ListRecentTagsResponse.prototype.setRecentTagsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.legebill.type.Tag=} opt_value
 * @param {number=} opt_index
 * @return {!proto.legebill.type.Tag}
 */
proto.legebill.site.tag.v4.ListRecentTagsResponse.prototype.addRecentTags = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.legebill.type.Tag, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.legebill.site.tag.v4.ListRecentTagsResponse} returns this
 */
proto.legebill.site.tag.v4.ListRecentTagsResponse.prototype.clearRecentTagsList = function() {
  return this.setRecentTagsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.tag.v4.DeleteTagRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.tag.v4.DeleteTagRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.tag.v4.DeleteTagRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.DeleteTagRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    tagId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.tag.v4.DeleteTagRequest}
 */
proto.legebill.site.tag.v4.DeleteTagRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.tag.v4.DeleteTagRequest;
  return proto.legebill.site.tag.v4.DeleteTagRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.tag.v4.DeleteTagRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.tag.v4.DeleteTagRequest}
 */
proto.legebill.site.tag.v4.DeleteTagRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTagId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.tag.v4.DeleteTagRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.tag.v4.DeleteTagRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.tag.v4.DeleteTagRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.DeleteTagRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTagId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string tag_id = 1;
 * @return {string}
 */
proto.legebill.site.tag.v4.DeleteTagRequest.prototype.getTagId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.tag.v4.DeleteTagRequest} returns this
 */
proto.legebill.site.tag.v4.DeleteTagRequest.prototype.setTagId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.tag.v4.GetTagCategoryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.tag.v4.GetTagCategoryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.tag.v4.GetTagCategoryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.GetTagCategoryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    tagCategoryId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.tag.v4.GetTagCategoryRequest}
 */
proto.legebill.site.tag.v4.GetTagCategoryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.tag.v4.GetTagCategoryRequest;
  return proto.legebill.site.tag.v4.GetTagCategoryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.tag.v4.GetTagCategoryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.tag.v4.GetTagCategoryRequest}
 */
proto.legebill.site.tag.v4.GetTagCategoryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTagCategoryId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.tag.v4.GetTagCategoryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.tag.v4.GetTagCategoryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.tag.v4.GetTagCategoryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.GetTagCategoryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTagCategoryId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string tag_category_id = 1;
 * @return {string}
 */
proto.legebill.site.tag.v4.GetTagCategoryRequest.prototype.getTagCategoryId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.tag.v4.GetTagCategoryRequest} returns this
 */
proto.legebill.site.tag.v4.GetTagCategoryRequest.prototype.setTagCategoryId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.legebill.site.tag.v4.BatchGetTagCategoriesRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.tag.v4.BatchGetTagCategoriesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.tag.v4.BatchGetTagCategoriesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.tag.v4.BatchGetTagCategoriesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.BatchGetTagCategoriesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    tagCategoryIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.tag.v4.BatchGetTagCategoriesRequest}
 */
proto.legebill.site.tag.v4.BatchGetTagCategoriesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.tag.v4.BatchGetTagCategoriesRequest;
  return proto.legebill.site.tag.v4.BatchGetTagCategoriesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.tag.v4.BatchGetTagCategoriesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.tag.v4.BatchGetTagCategoriesRequest}
 */
proto.legebill.site.tag.v4.BatchGetTagCategoriesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addTagCategoryIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.tag.v4.BatchGetTagCategoriesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.tag.v4.BatchGetTagCategoriesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.tag.v4.BatchGetTagCategoriesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.BatchGetTagCategoriesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTagCategoryIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string tag_category_ids = 1;
 * @return {!Array<string>}
 */
proto.legebill.site.tag.v4.BatchGetTagCategoriesRequest.prototype.getTagCategoryIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.legebill.site.tag.v4.BatchGetTagCategoriesRequest} returns this
 */
proto.legebill.site.tag.v4.BatchGetTagCategoriesRequest.prototype.setTagCategoryIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.legebill.site.tag.v4.BatchGetTagCategoriesRequest} returns this
 */
proto.legebill.site.tag.v4.BatchGetTagCategoriesRequest.prototype.addTagCategoryIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.legebill.site.tag.v4.BatchGetTagCategoriesRequest} returns this
 */
proto.legebill.site.tag.v4.BatchGetTagCategoriesRequest.prototype.clearTagCategoryIdsList = function() {
  return this.setTagCategoryIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.legebill.site.tag.v4.BatchGetTagCategoriesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.tag.v4.BatchGetTagCategoriesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.tag.v4.BatchGetTagCategoriesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.tag.v4.BatchGetTagCategoriesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.BatchGetTagCategoriesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    tagCategoriesList: jspb.Message.toObjectList(msg.getTagCategoriesList(),
    legebill_type_tag_category_pb.TagCategory.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.tag.v4.BatchGetTagCategoriesResponse}
 */
proto.legebill.site.tag.v4.BatchGetTagCategoriesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.tag.v4.BatchGetTagCategoriesResponse;
  return proto.legebill.site.tag.v4.BatchGetTagCategoriesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.tag.v4.BatchGetTagCategoriesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.tag.v4.BatchGetTagCategoriesResponse}
 */
proto.legebill.site.tag.v4.BatchGetTagCategoriesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new legebill_type_tag_category_pb.TagCategory;
      reader.readMessage(value,legebill_type_tag_category_pb.TagCategory.deserializeBinaryFromReader);
      msg.addTagCategories(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.tag.v4.BatchGetTagCategoriesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.tag.v4.BatchGetTagCategoriesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.tag.v4.BatchGetTagCategoriesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.tag.v4.BatchGetTagCategoriesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTagCategoriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      legebill_type_tag_category_pb.TagCategory.serializeBinaryToWriter
    );
  }
};


/**
 * repeated legebill.type.TagCategory tag_categories = 1;
 * @return {!Array<!proto.legebill.type.TagCategory>}
 */
proto.legebill.site.tag.v4.BatchGetTagCategoriesResponse.prototype.getTagCategoriesList = function() {
  return /** @type{!Array<!proto.legebill.type.TagCategory>} */ (
    jspb.Message.getRepeatedWrapperField(this, legebill_type_tag_category_pb.TagCategory, 1));
};


/**
 * @param {!Array<!proto.legebill.type.TagCategory>} value
 * @return {!proto.legebill.site.tag.v4.BatchGetTagCategoriesResponse} returns this
*/
proto.legebill.site.tag.v4.BatchGetTagCategoriesResponse.prototype.setTagCategoriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.legebill.type.TagCategory=} opt_value
 * @param {number=} opt_index
 * @return {!proto.legebill.type.TagCategory}
 */
proto.legebill.site.tag.v4.BatchGetTagCategoriesResponse.prototype.addTagCategories = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.legebill.type.TagCategory, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.legebill.site.tag.v4.BatchGetTagCategoriesResponse} returns this
 */
proto.legebill.site.tag.v4.BatchGetTagCategoriesResponse.prototype.clearTagCategoriesList = function() {
  return this.setTagCategoriesList([]);
};


goog.object.extend(exports, proto.legebill.site.tag.v4);
